import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 512,
	height: 512,
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M511.999 256H0V101.264C0 93.9392 3.95299 88 8.82798 88H503.172C508.047 88 512 93.9392 512 101.264L511.999 256Z",
		fill: "#F9F9F9"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M503.172 423H8.828C3.953 423 0 417.061 0 409.736V255H512V409.736C512 417.062 508.047 423 503.172 423Z",
		fill: "#FF4B55"
	})]
});
export default SvgPl;
